import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as AuthReducer from './auth.reducer';
import * as _ from 'lodash';

export const stateFeature = createFeatureSelector<AuthReducer.State>(
  AuthReducer.AuthFeatureKey
);

export const getAuth = createSelector(stateFeature, (state: AuthReducer.State) => state.auth);
export const getCurrentPartnerUuid = createSelector(stateFeature, (state: AuthReducer.State) => _.get(state, ['auth', 'partner_uuid'], undefined) as string | undefined);

export const isLoggingIn = createSelector(stateFeature, (state: AuthReducer.State) => state.loading);
export const isValidating = createSelector(stateFeature, (state: AuthReducer.State) => state.validating);
export const isLoggedIn = createSelector(stateFeature, (state: AuthReducer.State) => state.loaded);

export const isStatusChecked = createSelector(stateFeature, (state: AuthReducer.State) => state.checked);
